import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { CheckCircle2, X } from 'lucide-react';
const notifications = [{
  name: 'María L.',
  city: 'Buenos Aires',
  time: '2 minutos'
}, {
  name: 'Carlos R.',
  city: 'Córdoba',
  time: '5 minutos'
}, {
  name: 'Ana G.',
  city: 'Rosario',
  time: '1 minuto'
}, {
  name: 'Pablo M.',
  city: 'Mendoza',
  time: '10 minutos'
}, {
  name: 'Lucía S.',
  city: 'Tucumán',
  time: '3 minutos'
}, {
  name: 'Fernando D.',
  city: 'La Plata',
  time: '7 minutos'
}, {
  name: 'Valentina P.',
  city: 'Mar del Plata',
  time: '4 minutos'
}, {
  name: 'Santiago K.',
  city: 'Santa Fe',
  time: '8 minutos'
}];
export function PurchaseNotification() {
  const [currentNotification, setCurrentNotification] = useState<number | null>(null);
  const [isVisible, setIsVisible] = useState(false);
  useEffect(() => {
    // Initial delay before showing the first notification
    const initialTimer = setTimeout(() => {
      showNextNotification();
    }, 5000);
    return () => clearTimeout(initialTimer);
  }, []);
  const showNextNotification = () => {
    const randomIndex = Math.floor(Math.random() * notifications.length);
    setCurrentNotification(randomIndex);
    setIsVisible(true);
    // Auto-dismiss after 4 seconds
    setTimeout(() => {
      setIsVisible(false);
      // Schedule next notification after a random interval (8-12 seconds)
      const nextInterval = Math.floor(Math.random() * 4000) + 8000;
      setTimeout(() => {
        showNextNotification();
      }, nextInterval);
    }, 4000);
  };
  const handleClose = () => {
    setIsVisible(false);
  };
  return <div className="fixed bottom-4 left-4 right-4 md:right-auto md:left-6 md:bottom-6 z-50 pointer-events-none flex justify-center md:justify-start" data-id="element-222">
      <AnimatePresence data-id="element-223">
        {isVisible && currentNotification !== null && <motion.div initial={{
        opacity: 0,
        x: -100,
        scale: 0.9
      }} animate={{
        opacity: 1,
        x: 0,
        scale: 1
      }} exit={{
        opacity: 0,
        x: -100,
        scale: 0.9
      }} transition={{
        type: 'spring',
        stiffness: 400,
        damping: 25
      }} className="bg-brand-darkCard border border-slate-700/50 shadow-2xl rounded-xl p-3 md:p-4 flex items-center gap-3 w-full max-w-[340px] pointer-events-auto relative overflow-hidden" data-id="element-224">
            {/* Subtle highlight effect */}
            <div className="absolute top-0 left-0 w-1 h-full bg-green-500" data-id="element-225" />

            <div className="bg-green-500/10 p-2 rounded-full shrink-0" data-id="element-226">
              <CheckCircle2 className="w-5 h-5 md:w-6 md:h-6 text-green-500" data-id="element-227" />
            </div>

            <div className="flex-1 min-w-0 pr-4" data-id="element-228">
              <p className="text-[13px] md:text-sm text-slate-200 font-medium leading-tight mb-1" data-id="element-229">
                <span className="font-bold text-white" data-id="element-230">
                  {notifications[currentNotification].name}
                </span>{' '}
                de {notifications[currentNotification].city}
              </p>
              <p className="text-[11px] md:text-xs text-slate-400" data-id="element-231">
                Compró Protección Digital hace 7 minutos
              </p>
            </div>

            <button onClick={handleClose} className="absolute top-2 right-2 p-1 text-slate-500 hover:text-slate-300 transition-colors rounded-full hover:bg-slate-800" aria-label="Cerrar notificación" data-id="element-232">
              <X className="w-3.5 h-3.5" data-id="element-233" />
            </button>
          </motion.div>}
      </AnimatePresence>
    </div>;
}